import React from "react";
import { FaOilCan } from 'react-icons/fa';
import { RiPlantLine } from 'react-icons/ri';
import { BsFillDropletFill } from 'react-icons/bs';
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import SvGraphics from "../../../assets/SvGraphics";


class deliverySystemComposed extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
        }
    }



    render() {
        let {t} = this.props
        let {title} = this.state
        return (
            <div className={'PatientDashboardBox'}>
                <div className="PatientDashboardBox-item active">
                    <SvGraphics width={"41px"} height={"56px"} svgname={'drop-icon-ice-blue'}/>
                    <div>
                        <div className="PatientDashboardBox-item-num-label">0</div>
                        <div className="PatientDashboardBox-item-text-label">{t('doctor.patients')}</div>
                    </div>
                </div>

                <div className="PatientDashboardBox-item active">
                    <SvGraphics width={"41px"} height={"56px"} svgname={'marijuana-ice-blue'}/>
                    <div>
                        <div className="PatientDashboardBox-item-num-label">0</div>
                        <div className="PatientDashboardBox-item-text-label">{t('doctor.patients')}</div>
                    </div>
                </div>
                <div className="PatientDashboardBox-item active">
                    <SvGraphics width={"41px"} height={"56px"} svgname={'marijuana-ice-blue'}/>
                    <SvGraphics  width={"41px"} height={"56px"} svgname={'drop-icon-ice-blue'}/>

                    <div>
                        <div className="PatientDashboardBox-item-num-label">0</div>
                        <div className="PatientDashboardBox-item-text-label">{t('doctor.patients')}</div>
                    </div>
                </div>
            </div>
        );
    }
}
const deliverySystem = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(deliverySystemComposed);

export default deliverySystem;
